export function getCSSVar(name: string, element: HTMLElement = document.documentElement) {
  return getComputedStyle(element).getPropertyValue(`--${name}`)
}

export function removeCSSVar(name: string, element: HTMLElement = document.documentElement) {
  element.style.removeProperty(`--${name}`)
}

export function setCSSVar(name: string, value: string, element: HTMLElement = document.documentElement) {
  element.style.setProperty(`--${name}`, value)
}
